import cookies from 'browser-cookies';
import { authorizerTokenCookieExpirationDate, AuthType, forgeRevalidationCookie, } from '@innovyze/stylovyze/lib/types';
import { useReauthSharedWorkerProvider } from '@innovyze/stylovyze/lib/workers/SharedWorkerProvider';
import { DateTime } from 'luxon';
import { useEffect, useMemo } from 'react';
function useSharedWorkerExpiryDate(setOpen, hasSharedWorkers = false) {
    const { modalOpen: workerModalOpen, expirationTime } = useReauthSharedWorkerProvider();
    const sharedWorkerExpiryDate = useMemo(() => expirationTime
        ? DateTime.fromISO(String(expirationTime))
        : DateTime.local().plus({ minutes: 120 }), [expirationTime]);
    useEffect(() => {
        if (hasSharedWorkers)
            setOpen(workerModalOpen);
    }, [workerModalOpen]);
    return sharedWorkerExpiryDate;
}
export default function useAboutToExpireExpiryDate({ hasSharedWorkers, setOpen, mockDatesOffset, reloadDatesDeps, }) {
    const sharedWorkerExpiryDate = useSharedWorkerExpiryDate(
    // shared worker code
    // This code make the About to expire dumber, as it will always return the shared worker expiry date
    setOpen, hasSharedWorkers);
    const expiryDate = useMemo(() => {
        // Old code, without the shared worker
        // Remember to remove this after the shared worker is fully implemented and tested.
        const provider = localStorage.getItem('authentication.provider');
        let expiry;
        if (provider === AuthType.Auth0) {
            expiry = cookies.get(authorizerTokenCookieExpirationDate);
        }
        else {
            expiry = cookies.get(forgeRevalidationCookie);
        }
        const _expiryDate = expiry && DateTime.fromISO(expiry);
        if (_expiryDate) {
            if (!mockDatesOffset)
                return _expiryDate;
            return _expiryDate.plus(mockDatesOffset.expiryDateOffset);
        }
        return DateTime.local().plus({ minutes: 1 });
    }, [reloadDatesDeps]);
    if (hasSharedWorkers && sharedWorkerExpiryDate) {
        return sharedWorkerExpiryDate;
    }
    return expiryDate;
}
